import React from "react";
import { useSelector } from "react-redux";
import {Link} from 'react-router-dom';
import CheckboxButton from "../../../components/CheckboxButton";

const PolicySection = ({isAgree, handleChangeAgree}) => {
    const { companyInfo, type } = useSelector((state: any) => state.talentRegister);

    return (
        <>
        <div className='mb-4 w-full inline-block'>
            <ul className="gap-1 flex flex-col list-inside">
                {type != 'internal_talent' && 
                <li>
                    <Link to={'/privacy'} 
                        onClick={() => localStorage.setItem("privacy_policy", companyInfo?.privacy_policy || "")}
                        target="_blank" className='w-fit hover:bg-[#fff3e5] rounded p-1 flex items-center gap-1 text-link text-sm'>
                        個人情報の取り扱いについて（{companyInfo?.name}）
                        <span className="cursor-pointer">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                            >
                                <g clipPath="url(#clip0_16531_10607)">
                                <path
                                    d="M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z"
                                    fill="#FF861A"
                                />
                                </g>
                                <defs>
                                <clipPath id="clip0_16531_10607">
                                    <rect
                                    width="16"
                                    height="16"
                                    rx="4"
                                    fill="white"
                                    />
                                </clipPath>
                                </defs>
                            </svg>
                        </span>
                    </Link>
                </li>}
                <li>
                    <Link to={'/talent/terms-service'} target="_blank" className='w-fit hover:bg-[#fff3e5] rounded p-1 flex items-center gap-1 text-link text-sm'>
                    サービス利用規約について
                        <span className="cursor-pointer">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                            >
                                <g clipPath="url(#clip0_16531_10607)">
                                <path
                                    d="M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z"
                                    fill="#FF861A"
                                />
                                </g>
                                <defs>
                                <clipPath id="clip0_16531_10607">
                                    <rect
                                    width="16"
                                    height="16"
                                    rx="4"
                                    fill="white"
                                    />
                                </clipPath>
                                </defs>
                            </svg>
                        </span>
                    </Link>
                </li>
            </ul>
        </div>
        <div className='mb-4 w-full hidden md:inline-block'>
            <CheckboxButton
                tabindex={30}
                name={"agree"}
                label={type != 'internal_talent' ? "個人情報の取り扱いとサービス利用規約に同意する" : "サービス利用規約に同意する"}
                value={isAgree}
                onChange={handleChangeAgree}
            />
        </div>
        <div className='mb-8 w-full inline-block md:hidden text-agreed-to-terms'>
            <CheckboxButton
                name={"agree_mobile"}
                label={type != 'internal_talent' ? "個人情報の取り扱いとサービス利用規約に同意する" : "サービス利用規約に同意する"}
                value={isAgree}
                onChange={handleChangeAgree}
            />
        </div>
        </>
    );
};

export default PolicySection;
